import { render, staticRenderFns } from "./PaySucc.vue?vue&type=template&id=4bebc0ad"
var script = {}
import style0 from "./PaySucc.vue?vue&type=style&index=0&id=4bebc0ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports